import React from "react";

import PainelCovid from "../../components/page_components/PainelCovid";
import { PainelEstudoI } from "../../components/page_components/PainelEstudoI";
import PainelSentimentos from "../../components/page_components/PainelSentimentos";
import LoadingScreen from "../../components/StatusScreens/MediumLoadingScreen";
import { TabBar } from "../../components/TabBar";

function Painel(props) {
  const [tabIndex, setTabIndex] = React.useState(
    props.location.state ? props.location.state.index : 1
  );

  return (
    <>
      <TabBar tabIndex={tabIndex} setStateFunc={setTabIndex} />
      {tabIndex === 0 ? (
        <LoadingScreen />
      ) : (
        <>
          <PainelCovid hidden={tabIndex !== 1} />
          <PainelEstudoI hidden={tabIndex !== 3} />
          <PainelSentimentos hidden={tabIndex !== 2} />
        </>
      )}
    </>
  );
}

export default Painel;
